module.exports = __webpack_public_path__ + "static/media/mail.b8f9dd3b.svg";